import * as t from "io-ts";
import { ApplicantDetails } from "./ApplicantDetails";
import { BankAccount } from "./BankAccount";
import { CustomerDetails } from "./CustomerDetails";
import { EmploymentDetails } from "./EmploymentDetails";
import { FinanceDetails } from "./FinanceDetails";
import { Money } from "./Money";

export const LeadApplicant = t.intersection([
  t.type({
    customer_details: CustomerDetails,
    employment_details: EmploymentDetails,
    finance_details: FinanceDetails,
  }),
  t.partial({
    budget: Money,
    bank_account: BankAccount,
    additional_employment_details: t.array(EmploymentDetails),
    extra_applicants: t.array(ApplicantDetails),
  }),
]);

export interface LeadApplicant {
  budget?: Money;
  bank_account?: BankAccount;
  customer_details: CustomerDetails;
  employment_details: EmploymentDetails;
  additional_employment_details?: Array<EmploymentDetails>;
  finance_details: FinanceDetails;
  extra_applicants?: Array<ApplicantDetails>;
}
